var map = {
	"./navigation.de-CH.json": 1073,
	"./navigation.de-DE.json": 1074,
	"./navigation.en-CA.json": 1075,
	"./navigation.en-GB.json": 1076,
	"./navigation.en-IN.json": 1077,
	"./navigation.en-ME.json": 1078,
	"./navigation.en-US.json": 1079,
	"./navigation.es-EM.json": 1080,
	"./navigation.es-ES.json": 1081,
	"./navigation.fr-BE.json": 1082,
	"./navigation.fr-CA.json": 1083,
	"./navigation.fr-CH.json": 1084,
	"./navigation.nl-BE.json": 1085,
	"./navigation.nl-NL.json": 1086,
	"./navigation.pl-PL.json": 1087,
	"./navigation.pt-BR.json": 1088
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1072;